module.exports = __webpack_public_path__ + "static/media/SBI_Mutual_Fund.92c56aad.pdf";